import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";

import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Drawer from "@mui/material/Drawer";
import Chip from "@mui/material/Chip"; // Added import
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import EditSearchPolicy from "./EditSearchPolicy";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import moment from "moment";
import {
  RemoveRedEyeIcon,
  SearchIcon,
  CloudOffIcon,
  DownloadIcon,
  EditIcon,
  DeleteIcon,
  BugReportIcon, // Added import
} from "../../../Resources/Icons/icons";
import { DownloadOutlined, DescriptionOutlined } from "@mui/icons-material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FileUploader } from "react-drag-drop-files";
import {
  AWS_DIRECTORY_NAME,
  PolicyFilterTypes,
  FilterOption,
  checkUserType,
} from "../../../Shared/CommonConstant";
//import Loader from "../../../UiComponents/Loader/Loader";
import * as Yup from "yup";
import {
  GetPolicyFileById,
  GetCompany,
  GetPolicyList,
  GetProduct,
  FilterPolicyList,
  UpdatePolicyList,
  GetPolicyFindbyId,
  DeletePolicyList,
  PostSearchPolicy,
  GetUser,
  GetBookingCode,
  GetSubBookingCode,
  getCPAList,
} from "../../../Service/_index";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Formik, Form, Field } from "formik";
import { CSVLink } from "react-csv";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Divider, Stack, Badge } from "@mui/material";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";
import Loader from "../../../UiComponents/Loader/Loader";
import { DatePicker } from "antd";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import CloseIcon from "@mui/icons-material/Close";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "registrationNumber",
    placeMent: true,
    disablePadding: false,
    label: "Reg Number",
  },
  {
    id: "product",
    placeMent: true,
    disablePadding: false,
    label: "Product",
  },
  // Changes by Arun
  {
    id: "paymentMode",
    placeMent: true,
    disablePadding: false,
    label: "Payment Mode",
  },
  // {
  //   id: "odPremium",
  //   placeMent: true,
  //   disablePadding: false,
  //   label: "OD Pre",
  // },
  {
    id: "netPremium",
    placeMent: true,
    disablePadding: false,
    label: "Net Pre",
  },
  {
    id: "totalPremium",
    placeMent: true,
    disablePadding: false,
    label: "Total Pre",
  },
  {
    id: "userEmail",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
  {
    id: "policyStatus",
    placeMent: true,
    disablePadding: false,
    label: "Policy Status",
    type: "button",
    buttonLabel: "Entry Pending",
    buttonColor: "success",
    buttonClass: "Dynamic_Button",
  },
];

const RejectedCells = [
  {
    id: "policyDate",
    placeMent: true,
    disablePadding: false,
    label: "Policy Date",
  },
  {
    id: "companyName",
    placeMent: true,
    disablePadding: false,
    label: "Company Name",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "email",
    placeMent: true,
    disablePadding: false,
    label: "User Email",
  },
  {
    id: "policyStatus",
    placeMent: true,
    disablePadding: false,
    label: "Policy Status",
  },
  {
    id: "rejectedReason",
    placeMent: true,
    disablePadding: false,
    label: "Rejected Reason",
  },
  {
    id: "action",
    placeMent: false,
    disablePadding: false,
    label: "Action",
  },
];

const onlinePolicyHeadCells = [
  { id: "fullName", label: "Customer Name", placeMent: true },
  { id: "email", label: "User Email", placeMent: true },
  { id: "vehicleMake", label: "Make", placeMent: true },
  { id: "idv", label: "IDV", placeMent: true },
  {
    id: "pincode",
    label: "Pincode",
    placeMent: true
  },
  { id: "vehicleCC", label: "Vehicle CC", placeMent: true },
  { id: "paCoverText", label: "PA Cover", placeMent: true },
  {
    id: "status",
    label: "Job Status",
    placeMent: true,
    type: "coloredText",
    getColor: (row) => {
      switch (row?.status?.toLowerCase()) {
        case 'completed': return 'green';
        case 'pending': return 'orange';
        case 'failed': return 'red';
        default: return 'black';
      }
    }
  },
];

const cpaListHeadCells = [
  // {
  //   id: "sNo",
  //   label: "S.No",
  //   placeMent: true,
  //   disablePadding: false,
  // },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "customerName",
    placeMent: true,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "policyType",
    label: "Policy Type",
    placeMent: true,
    disablePadding: false,
  },
  {
    id: "totalPremium",
    label: "Total Premium",
    placeMent: true,
    disablePadding: false,
  },
  {
    id: "policyPremium",
    label: "Policy Premium",
    placeMent: true,
    disablePadding: false,
  },
  {
    id: "paymentMode",
    label: "Payment Mode",
    placeMent: true,
    disablePadding: false,
  },
  {
    id: "formattedDate",
    label: "Created Date",
    placeMent: true,
    disablePadding: false,
  },
  {
    id: "status",
    label: "Status",
    placeMent: true,
    disablePadding: false,
    type: "coloredText",
    getColor: (row) => (row.status === "CREATED" ? "green" : "red"),
  },
  {
    id: "action_certificate", // Unique ID
    label: "Certificate", // Renamed from Action
    placeMent: false,
    disablePadding: false,
    type: "button",
    buttonLabel: "CPA", // Renamed
    buttonColor: "primary", // Changed color for distinction
    buttonVariant: "outlined",
    actionType: "certificate",
    icon: <DownloadOutlined />,
    condition: (row) => row.status === "CREATED" && row.downloadUrl,
    buttonClass: "custom-download-button",
  },
];

const SearchOption = [
  {
    option: "policyNumber",
    value: 1,
    label: "Policy Number",
    _id: 1,
  },
  {
    option: "registrationNumber",
    value: 2,
    label: "Registeration Number",
    _id: 2,
  },
  {
    option: "customerName",
    value: 3,
    label: "Customer Name",
    _id: 3,
  },
  {
    option: "mobileNumber",
    value: 4,
    label: "Mobile Number",
    _id: 4,
  },
  {
    option: "email",
    value: 5,
    label: "Email",
    _id: 5,
  },
];
function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, rejectedPolicy } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  // const celltoMap = rejectedPolicy ? RejectedCells : headCells;

  const celltoMap =
    sessionStorage.getItem("userType") == "SUBCODE"
      ? headCells.filter((e) => e.label !== "User Email")
      : headCells;

  return (
    <TableHead>
      <TableRow>
        {celltoMap?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const SearchPolicy = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [selectedData, setSelectedData] = React.useState({});
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [openEditPolictDrawer, setOpenEditPolicyDrawer] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedproduct, setSelectedProduct] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedSearchOption, setSelectedSearchOption] = useState(null);
  const [searchOptionText, setSearchOptionText] = useState(null);
  const [openUploadFileBox, setOpenUploadFileBox] = useState(false);
  const [uploadFiles, setUploadFiles] = useState({});
  const [policyCount, setPolicyCount] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [editType, setEditType] = useState();
  const [isEditRejectPopup, setIsEditRejectPopup] = useState(false);
  const [rejectedPolicyNumber, setRejectdPolicyNumber] = useState(null);
  const [showRejectedPolicyTable, setShowRejectedPolicyTable] = useState(false);
  const [formType, setFormType] = useState();
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [placeHolder, setPlaceHolder] = useState("Search Option");
  const [type, setType] = useState();
  const [input, setInput] = useState();
  const [disableSearchButton, setDisableSearchButton] = React.useState(true);
  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [showFilter, setShowFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: false,
    isView: true,
    isEdit: true,
    isDelete: false,
    isSearch: true,
    isUpload: true,
    isFileDownload: true,
    isApprove: false,
  });
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [userDetails, setUserDetails] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState(null);
  const [collectionType, setCollectionType] = useState("onlinePolicy");

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(policyList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, policyList]
  );

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getLabelForValue = (value) => {
    const option = PolicyFilterTypes.find((option) => option.value === value);
    return option ? option.label : null;
  };

  const validationSchema = Yup.object().shape({
    textField: Yup.string().required(`Enter The ${placeHolder}`),
    searchType: Yup.string().required("Enter Search Type"),
  });

  const handleKeyDown = (e) => {
    if (
      placeHolder === "Policy Number" ||
      placeHolder === "Registeration Number" ||
      placeHolder === "Mobile Number"
    ) {
      if (e.key === " ") {
        e.preventDefault();
      }
    }
  };

  const onSubmit = () => {
    if (selectedSearchOption && searchOptionText) {
      const selectedOpt = SearchOption.find(
        (opt) => opt._id === selectedSearchOption
      );
      const searchKey = selectedOpt ? selectedOpt.option : null;

      if (searchKey) {
        // Check collection type and call appropriate API
        if (collectionType === "cpaList") {
          // Call CPA List API
          const searchParams = {
            search: searchOptionText,
            page: 1,
            limit: 100
          };

          getCPAList(searchParams).then((res) => {
            const formattedData = res?.data?.map((e, index) => ({
              ...e,
              sNo: (1 - 1) * 100 + index + 1,
              policyDate: moment(e.createdAt).format("DD/MM/YYYY"),
              companyName: "Brisk",
              product: e?.planName || "CPA",
              userEmail: "",
              policyStatus: e?.status,
              formatStatus: e?.status,
              formattedDate: e.createdAt ? moment(e.createdAt).format("DD-MM-YYYY HH:mm:ss") : "-",
              policyType: "CPA/RSA",
              customerName: e?.payload?.CustomerName || e?.policyNumber || "-",
              totalPremium: e?.totalPremium || "-",
              policyPremium: e?.policyPremium || "-",
              paymentMode: e?.paymentMode || "-",
            }));
            setPolicyList(formattedData);
            setPolicyCount(res.total || 0);
          });
        } else {
          // Call Online Policy API
          const PostData = {
            [searchKey]: searchOptionText?.toUpperCase(),
          };
          PostSearchPolicy(PostData).then((res) => {
            const formattedData = res?.data?.map((e) => ({
              ...e,
              policyDate: moment(e.issueDate).format("DD/MM/YYYY"),
              companyName: e?.companyId?.shortName,
              product: e?.productId?.product,
              userEmail: e?.userId?.email,
              policyStatus:
                e?.status?.charAt(0).toUpperCase() + e?.status?.slice(1),
              formatStatus:
                e?.status === "rejectedPolicy"
                  ? "Rejected Policy"
                  : e?.status === "cancelled"
                    ? "Cancelled"
                    : "approvePending"
                    ? "Approved"
                    : "chequePending"
                      ? "Cheque Pending"
                      : e?.status,
            }));
            setPolicyList(formattedData);
          });
        }
      }
    }
  };

  React.useEffect(() => {
    if (selectedSearchOption && searchOptionText) {
      onSubmit();
    }
  }, [collectionType]);

  const handleDownloadCertificate = (row) => {
    if (row.downloadUrl) {
      window.open(row.downloadUrl, "_blank");
    } else {
      console.warn("No download URL available for this certificate");
    }
  };

  const EditPolicyListData = (row) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id).then((res) => {
      setOpenLoader(false);
      setOpenEditPolicyDrawer(true);
      setSelectedData(res?.data);
      setEditType(
        row.status === PolicyFilterTypes.find(f => f.value === "verifyPending")?.value ||
          row.status === PolicyFilterTypes.find(f => f.value === "approvePending")?.value
          ? "EntryPending"
          : // : row.status === PolicyFilterTypes.find(f => f.value === "rejectedPolicy")?.value
          "CommonEdit"
      );
      setFormType("edit");
    });
  };

  const EditRejectedPolicyData = (row) => {
    setIsEditRejectPopup(true);
    setSelectedData(row);
  };

  const EditRejectedPolicyFunction = () => {
    setOpenLoader(true);
    const data = {};
    data.policyNumber = rejectedPolicyNumber;
    data.status = PolicyFilterTypes.find(f => f.value === "verifyPending")?.value;
    data.rejectedReason = "";
    UpdatePolicyList(selectedData?._id, data)
      .then(() => {
        setOpenLoader(false);
        setIsEditRejectPopup(false);
        UniversalSearch();
        ToastSuccess("Retrived Succesfully");
      })
      .catch((err) => {
        setOpenLoader(false);
        ToastError("NetWork Error");
      });
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  const ViewPolicyFunction = (row) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id).then((res) => {
      setOpenLoader(false);
      setOpenEditPolicyDrawer(true);
      setSelectedData(res?.data);
      setFormType("view");
    });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.companyId?.companyName},${el?.policyNumber},${el?.customerName
              },${el?.registrationNumber},${el?.productId?.product},${el?.odPremium
              },${el?.netPremium},${el?.totalPremium},${el?.userId?.email},${el?.status
              },${moment(el.issueDate).format("D-M-Y")}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const UniversalSearch = () => {
    FilterPolicyList({
      companyId: selectedCompany?._id,
      productId: selectedproduct?._id,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      status: selectedStatus,
    })
      .then((res) => {
        const formattedData = res?.data.map((e) => ({
          ...e,
          policyDate: moment(e.issueDate).format("DD/MM/YYYY"),
          companyName: e?.companyId?.shortName,
          product: e?.productId?.product,
          userEmail: e?.userId?.email,
          policyStatus:
            e?.status?.charAt(0).toUpperCase() + e?.status?.slice(1),
          formatStatus:
            e?.status === "rejectedPolicy"
              ? "Rejected Policy"
              : e?.status === "cancelled"
                ? "Cancelled"
                : "approvePending"
                ? "Approved"
                : "chequePending"
                  ? "Cheque Pending"
                  : e?.status,
        }));
        setPolicyList(formattedData);
        setShowRejectedPolicyTable(
          selectedStatus === PolicyFilterTypes.find(f => f.value === "rejectedPolicy")?.value ? true : false
        );
        const totalPremiumValues = res?.data?.map((e) => e.totalPremium);
        setPolicyCount(totalPremiumValues);
      })
      .catch((err) => {
        console.log("err");
      });
  };
  const TriggerUploadFilesFunction = () => {
    setOpenUploadFileBox(true);
  };
  const UploadFilesFunction = () => {
    let formData = new FormData();
    for (var key in uploadFiles) {
      formData.append(key, uploadFiles[key]);
    }
    formData.append(
      AWS_DIRECTORY_NAME.AWS_POLICY_FILE_DIRECTORY_NAME,
      uploadFiles.policyFile
    );
    formData.append(
      AWS_DIRECTORY_NAME.AWS_OTHER_FILE_DIRECTORY_NAME,
      uploadFiles.otherFile
    );
    UpdatePolicyList(selectedData?._id, formData)
      .then((res) => {
        setOpenUploadFileBox(false);
      })
      .catch((err) => {
        console.log(err);
        ToastError("Something Went error");
        setOpenUploadFileBox(false);
      });
  };

  const UserType = sessionStorage.getItem("userType");
  const isRemoveFields = [
    PolicyFilterTypes.find(f => f.value === "verifyPending")?.value,
    PolicyFilterTypes.find(f => f.value === "approvePending")?.value,
    PolicyFilterTypes.find(f => f.value === "approvedPolicy")?.value,
    PolicyFilterTypes.find(f => f.value === "rejectedPolicy")?.value,
  ];
  const UserFilterOption = PolicyFilterTypes.filter((item) =>
    isRemoveFields.includes(item.value)
  );
  const PolicyFilterOption =
    UserType === FilterOption[3].value ? UserFilterOption : PolicyFilterTypes;
  const [isAllow, setIsAllow] = useState({});

  React.useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, []);

  const DownloadFileFunction = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row?._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        const base64PDFUrl = pdfUrl;
        const byteCharacters = atob(base64PDFUrl);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "downloaded_pdf.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };

  const DeletePolicyData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    DeletePolicyList(selectedData._id).then(() => {
      onSubmit();
    });
    setOpenDeleteConfirmBox(false);
  };

  const [selectedText, setSelectedText] = useState();

  const implementCond = (cell) => {
    return cell.map((obj) =>
      obj.id === "policyStatus"
        ? {
          ...obj,
          condition: (row) =>
            ["entryPending", "verifyPending"].includes(row?.status),
          fallbackText: (row) => row?.formatStatus,
          newLabel: (row) => {
            switch (row?.status) {
              case "entryPending":
                return "Entry Pending";
              case "verifyPending":
                return "Verify Pending";
              case "approvePending":
                return "Approved";
              case "approvedPolicy":
                return "Approved";
              case "chequePending":
                return "Cheque";
              case "rejectedPolicy":
                return "Rejected";
              default:
                return undefined;
            }
          },
          behaviour: (row) => {
            switch (row?.status) {
              case "entryPending":
                return EditPolicyListData;
              case "verifyPending":
                return EditPolicyListData;
              case "approvePending":
              // return EditPolicyListData;
              case "chequePending":
              // return EditPolicyListData;
              case "approvedPolicy":
              // return EditPolicyListData;
              case "rejectedPolicy":
              // return EditPolicyListData;
              default:
                return null;
            }
          },
        }
        : obj
    );
  };

  // Get User, Company, Booking Code, SubBookingCode Details
  const GetUserDetails = () => {
    const bodyData = {
      requesttype: "TABLE",
      isAscending: true,
    };
    GetUser(bodyData)
      .then((res) => {
        const modifiedUserDetails = res.data
          .map((e) => {
            if (e.userType.includes("user") && e.isEnabled) {
              return {
                ...e,
                label: e?.name + " - " + e?.mobileNumber + " - " + e?.email,
                value: e._id,
              };
            }
          })
          .filter(Boolean);
        setUserDetails(modifiedUserDetails);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails.sort());
    });
  };

  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCode);
    });
  };

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      const filteredSubBookingCode = modifiedSubBookingCode.filter(
        (item) =>
          item.bookingCodeId === selectedBookingCode?._id ||
          item.bookingCodeId === selectedBookingCode
      );
      setSubBookingCodeDetails(filteredSubBookingCode);
    });
  };

  React.useEffect(() => {
    GetSubBookingCodeDetails();
  }, [selectedBookingCode]);

  React.useEffect(() => {
    GetUserDetails();
    GetCompanyDetails();
    GetBookingCodeDetails();
  }, []);

  const handleClearAllState = () => {
    setSelectedSearchOption(null);
    setSearchOptionText(null);
  };

  const handleSaveAllFilter = () => {
    onSubmit();
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedSearchOption(null);
    } else if (filterId === 2) {
      setSearchOptionText(null);
    }
  };
  const activeFiltersCount = [selectedSearchOption, searchOptionText].filter(
    Boolean
  ).length;

  const CollectionTypeOptions = [
    {
      option: "onlinePolicy",
      value: 1,
      label: "Online Policy",
      _id: 1
    },
    {
      option: "cpaList",
      value: 2,
      label: "CPA List",
      _id: 2
    }
  ];

  const filterBoxData = [
    {
      id: 3,
      label: "Collection Type",
      type: "button",
      data: [
        { label: "Online Policy", value: "onlinePolicy" },
        { label: "CPA List", value: "cpaList" }
      ],
      value: collectionType,
      setState: (value) => {
        setCollectionType(value);
        setPolicyList([]);
      },
      alwaysShowDropdown: true,
    },
    {
      id: 1,
      label: "Select Search Type",
      data: SearchOption,
      setState: setSelectedSearchOption,
      value: selectedSearchOption,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: selectedSearchOption
        ? SearchOption.find((opt) => opt._id === selectedSearchOption)?.label
        : "Search Option",
      setState: setSearchOptionText,
      value: searchOptionText,
      type: "normalInput",
    },
  ];

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
      case 'complete':
      case 'success':
        return 'success';
      case 'pending':
      case 'in progress':
      case 'incomplete':
        return 'warning';
      case 'failed':
      case 'rejected':
      case 'cancelled':
        return 'error';
      default:
        return 'default';
    }
  };

  const FilteredData = policyList?.map(row => {
    // Only apply transformation if we are in onlinePolicy mode
    if (collectionType === "onlinePolicy") {
      return {
        ...row,
        paCoverText: row.paCover ? "Yes" : "No",
      };
    }
    return row;
  })?.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const policyListDetails =
      `${el?.companyName},${el?.paymentMode},${el?.email},${el?.customerName},${el?.product},${el?.registrationNumber},${el?.policyNumber},${el?.paymentMode},${el?.userEmail},${el?.policyStatus},${el?.fullName}`.toLowerCase();
    return policyListDetails.includes(searchTerm);
  });

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Search Policy
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          color="error"
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                    handleButtonClick={(value) => {
                      setCollectionType(value);
                      setPolicyList([]);
                    }}
                    selectedButton={collectionType}
                  />
                </Box>
              )}
              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                <Grid item xs={12} sm={8} md={8}></Grid>
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search User"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={
                  collectionType === "cpaList"
                    ? { ...tableConfig, isAction: false, isView: false, isEdit: false, isDelete: false, isUpload: false, isFileDownload: false }
                    : tableConfig
                }
                data={FilteredData}
                // columns={headCells}
                columns={
                  collectionType === "onlinePolicy"
                    ? onlinePolicyHeadCells
                    : collectionType === "cpaList"
                      ? cpaListHeadCells
                      : implementCond
                        ? implementCond(headCells)
                        : headCells
                }
                // isServerSide={true}
                handleOnClickBehaviour={OpenPolicyFile}
                handleView={ViewPolicyFunction}
                handleEdit={
                  policyList.status === PolicyFilterTypes.find(f => f.value === "rejectedPolicy")?.value
                    ? EditRejectedPolicyData
                    : EditPolicyListData
                }
                handleDelete={DeletePolicyData}
                handleDownload={DownloadFileFunction}
                handleUpload={TriggerUploadFilesFunction}
                handleButton={{
                  "Entry Pending": EditPolicyListData,
                  "CPA": handleDownloadCertificate,
                }}
                // handleButton2={handleButton}
                tableTotalCount={collectionType === "cpaList" ? policyCount : filter.fn(policyList)?.length || 0}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>

      <Drawer
        open={openEditPolictDrawer}
        sx={{ zIndex: 100 }}
        anchor="right"
        PaperProps={{ sx: { width: { xs: "100%", sm: "100%" } } }}
      >
        {openEditPolictDrawer ? (
          <EditSearchPolicy
            editType={editType}
            GetData={onSubmit}
            type={type}
            input={input}
            setOpenEditPolicyDrawer={setOpenEditPolicyDrawer}
            openEditPolictDrawer={openEditPolictDrawer}
            selectedData={selectedData}
            formType={formType}
          />
        ) : null}
      </Drawer>
      <div>
        <Dialog
          open={openUploadFileBox}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="DrawerContainer">
            <Grid
              container
              className="DrawerHeader"
              sx={{ marginBottom: "0px !important" }}
            >
              <Grid item xs={6} sm={6}>
                <Typography>Upload Policy Documents</Typography>
              </Grid>
              <Grid item xs={6} sm={6} className="d-flex justify-content-end">
                <CloseIcon
                  onClick={() => setOpenUploadFileBox(false)}
                  sx={{
                    cursor: "pointer",
                    height: "18px",
                    width: "18px",
                    fontWeight: 600,
                  }}
                />
              </Grid>
            </Grid>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Grid container rowGap={1}>
                  <Grid item className="File-Upload" xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        mb: 1,
                        color: "black",
                        fontWeight: 400,
                        paddingBottom: "4px",
                      }}
                    >
                      Policy File
                    </Typography>{" "}
                    <FileUploader
                      name="OtherFile"
                      label="Upload Your Policy File"
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                      handleChange={(e) =>
                        setUploadFiles({ ...uploadFiles, policyFile: e })
                      }
                    />
                  </Grid>
                  <Grid item className="File-Upload" xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        mb: 1,
                        color: "black",
                        fontWeight: 400,
                        paddingBottom: "4px",
                      }}
                    >
                      Other Documnets File
                    </Typography>{" "}
                    <FileUploader
                      name="OtherFile"
                      label="Upload Your Other Document"
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                      handleChange={(e) =>
                        setUploadFiles({ ...uploadFiles, otherFile: e })
                      }
                    />
                  </Grid>
                </Grid>
              </DialogContentText>
            </DialogContent>
            <div className="Dialog_Footer">
              <Button
                onClick={() => {
                  setOpenUploadFileBox(false);
                }}
                className="Dialog_Cancel"
              >
                Close
              </Button>
              <Button
                autoFocus
                onClick={() => UploadFilesFunction()}
                className="Dialog_Save"
              >
                Update
              </Button>
            </div>
          </div>
        </Dialog>
        {/* <Loader open={openLoader} /> */}
      </div>

      <React.Fragment>
        <Dialog
          open={isEditRejectPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Rejected Policy Update
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" mt={2}>
              <FloatLabel label="Policy Number" value="s">
                <TextField
                  className="w-100"
                  onChange={(e) => setRejectdPolicyNumber(e.target.value)}
                />
              </FloatLabel>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsEditRejectPopup(false)}>Close</Button>
            <Button autoFocus onClick={() => EditRejectedPolicyFunction()}>
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
    </>
  );
};
export default SearchPolicy;
